import { useTranslation } from "react-i18next";
import OrgFiltersSection from "@/components/Shared/Filters/OrgFiltersSection";
import LoadingIndicator from "@/components/Shared/LoadingIndicator/LoadingIndicator";
import { EMPTY_JOB_DEFINITION } from "@/models/JobFilter";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import JobFilterBuilder from "@/pages/Jobs/components/JobFilterBuilder";
import { useJobFilterData } from "@/pages/Jobs/components/useJobFilterData";

const UppdragsfilterPage = () => {
	const { t } = useTranslation();
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation, isLoading: isSaving } = useUpdateOrganisation();
	const { options, isLoading } = useJobFilterData();

	if (isLoading) return <LoadingIndicator />;

	return (
		<div className="max-w-2xl">
			<OrgFiltersSection
				title={t("ORG_JOB_FILTERS" as any, "Jobbfilter")}
				description={t(
					"ORG_JOB_FILTERS_DESC" as any,
					"Delade filter för jobblistan, tillgängliga för alla i organisationen."
				)}
				kbTag="job-filters"
				emptyTitle={t("ORG_JOB_FILTERS_EMPTY_TITLE" as any, "Inga jobbfilter än")}
				emptyDesc={t(
					"ORG_JOB_FILTERS_EMPTY_DESC" as any,
					"Skapa delade filter som alla i organisationen kan använda på jobblistan."
				)}
				filters={organisation?.jobFilters ?? []}
				isSaving={isSaving}
				onSave={(next) => updateOrganisation({ jobFilters: next } as any)}
				emptyDefinition={EMPTY_JOB_DEFINITION}
				renderBuilder={(def, change) => (
					<JobFilterBuilder definition={def} onChange={change} options={options} />
				)}
			/>
		</div>
	);
};

export default UppdragsfilterPage;
